import {
  startDurationTracking,
  recordSpan,
  completeDurationTracking,
} from '../durationTracking';
import { ViewLoadMetrics } from '../types';
import { EVENT_NAMES } from '../config';

/**
 * Standardized span names for view load tracking
 */
const SPAN_NAMES = {
  VIEW_MODEL_READY: 'view-model-ready',
} as const;

export const DEFAULT_EXPECTED_DURATION = 20_000;

/**
 * Start tracking view load performance
 */
export const startViewLoadTracking = (
  viewName: string,
  expectedDuration?: number
): string =>
  startDurationTracking(
    EVENT_NAMES.VIEW_LOAD_PERFORMANCE,
    { viewName },
    expectedDuration
  );

/**
 * Record that the view model is ready with associated metrics
 */
export const recordViewModelReady = (
  trackingId: string,
  metrics: ViewLoadMetrics
) => recordSpan(trackingId, SPAN_NAMES.VIEW_MODEL_READY, metrics);

/**
 * Record that the view render is complete and finalize tracking
 */
export const recordRenderComplete = (trackingId: string) =>
  completeDurationTracking(trackingId);
